import { Brand } from '../brand';

import styles from './style.module.css';

// The frame of the screens before the app: sign-in, the code and onboarding.
// The brand sits where the top bar would be, its name beside the mascot on a
// desktop and, on the sign-in screen, on a phone too (nameOnPhone). The
// content is one card, edge to edge on a phone and a centred 520px card with
// the hard shadow on a desktop.
export function Centered({ nameOnPhone, children }) {
  return (
    <>
      <header className={ styles.header }>
        <Brand size={ 36 } nameOnPhone={ nameOnPhone }/>
      </header>

      <main className={ styles.card }>{ children }</main>
    </>
  );
}
